import React from 'react';
import PropTypes from 'prop-types';
import { ArticleHead, ArticleTitle, ArticleCard, ArticleAuthor } from '.';
import { Link } from 'react-router';
import { calendarTime, imageResizeBaseUrl } from './../../utilities.js';
import moment from 'moment';
import './standardArticle.css';
import noImg from '../../assets/no-image-small.png';
import noImgBig from '../../assets/no-image.png';
import { getProp } from '../../utilities';

const StandardArticle = props => {
  let creationDate = calendarTime(moment(props.article.date));

  let img = getProp(props.article, 'picture.uri', null);
  let shareImg = img;
  if (props.imgOverride) {
    img = props.imgOverride;
    shareImg = img;
  } else if (img !== null) {
    img = `${imageResizeBaseUrl(props.pictureSize)}/${img}`;
    shareImg = img;
  } else {
    img = noImgBig;
  }

  let url = `${props.baseUrl}/clanok/${props.article._id}`;
  if (props.article.url) {
    url = `${props.baseUrl}/${props.article.url}`;
  }

  let viewsText = 'videní';
  let views = getProp(props.article, 'views_total', 0);
  if (views === 1) {
    viewsText = 'videnie';
  } else if (views >= 2 && views <= 4) {
    viewsText = 'videnia';
  }

  let shareUrl;
  if (props.baseUrl !== '') {
    shareUrl = url;
  } else {
    shareUrl = `${process.env.REACT_APP_BASE_URL}${url}`;
  }

  let authorPicture = getProp(props.article, 'author.picture', null);
  if (authorPicture) {
    authorPicture = `${imageResizeBaseUrl(100)}/${authorPicture}`;
  } else {
    authorPicture = noImg;
  }

  return (
    <article className={`article ${props.size ? `article-${props.size}` : ''}`}>
      <CustomLink to={url} external={props.baseUrl !== ''}>
        <ArticleHead
          image={img}
          title={
            <ArticleTitle
              title={<strong>{props.article.name}</strong>}
              subtitle={
                typeof props.articleTitleSubtitle !== 'undefined'
                  ? props.articleTitleSubtitle
                  : `${getProp(props.article, 'author.name')}, ${creationDate}`
              }
              extra={props.articleTitleExtra}
              allowShare={props.allowShare}
            />
          }
          shareUrl={shareUrl}
          shareTitle={props.article.name}
          sharePicture={shareImg}
        >
          {props.articleHeadContent}
        </ArticleHead>
      </CustomLink>
      {props.extended && (
        <ArticleCard>
          {props.articleAuthorShow && (
            <ArticleAuthor
              title={`${getProp(
                props.article,
                'author.name',
              )}, ${creationDate}`}
              subtitle={props.articleAuthorSubtitle}
              image={authorPicture}
            />
          )}
          <div className="article-perex">{props.article.perex}</div>
        </ArticleCard>
      )}
      {props.viewCountShow &&
        props.article.views_total && (
          <div className="views-total">
            <span>{props.article.views_total}</span> {viewsText}
          </div>
        )}
    </article>
  );
};

StandardArticle.defaultProps = {
  extended: false,
  viewCountShow: false,
  pictureSize: 600,
  baseUrl: '',
  allowShare: true,
  size: '',
  articleAuthorShow: false,
};

StandardArticle.propTypes = {
  extended: PropTypes.bool,
  articleAuthorSubtitle: PropTypes.object,
  article: PropTypes.object.isRequired,
  articleTitleSubtitle: PropTypes.node,
  articleTitleExtra: PropTypes.node,
  viewCountShow: PropTypes.bool,
  pictureSize: PropTypes.number,
  baseUrl: PropTypes.string,
  imgOverride: PropTypes.string,
  allowShare: PropTypes.bool,
  size: PropTypes.string,
  articleAuthorShow: PropTypes.bool,
  articleHeadContent: PropTypes.node,
};

export default StandardArticle;

const CustomLink = props => {
  return props.external ? (
    <a href={props.to} target="_blank">
      {props.children}
    </a>
  ) : (
    <Link to={props.to}>{props.children}</Link>
  );
};

CustomLink.defaultProps = {
  external: false,
};

CustomLink.propTypes = {
  external: PropTypes.bool,
  to: PropTypes.string.isRequired,
  children: PropTypes.node.isRequired,
};



// WEBPACK FOOTER //
// ./src/ui/src/component/article/standardArticle.js